module.exports = __webpack_public_path__ + "img/org_users-sqr.1418fecb.svg";